import script from "./NewDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NewDialog.vue?vue&type=script&setup=true&lang=js"

import "./NewDialog.vue?vue&type=style&index=0&id=21c299c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c299c6"]])

export default __exports__